// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressResponse } from './address-response';

/** See com.rev360.pms.api.controller.admin.vendorsandpartners.vendor.ThirdPartyAdministratorResponse */
/* istanbul ignore next */
@GandalfModel
export class ThirdPartyAdministratorResponse extends GandalfModelBase {

	@GandalfProperty({ designType: AddressResponse })
	address!: AddressResponse | null;

	@GandalfProperty({ designType: String })
	contactEmail!: string | null;

	@GandalfProperty({ designType: String })
	contactName!: string | null;

	@GandalfProperty({ designType: String })
	contactPhone!: string | null;

	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfProperty({ designType: String })
	fax!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	mainPhone!: string | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: String })
	npi!: string | null;

	@GandalfConstantDecorator(constants.BusinessStatus)
	@GandalfProperty({ designType: constants.BusinessStatus })
	status!: constants.BusinessStatus | null;

	@GandalfProperty({ designType: String })
	tollFree!: string | null;

	@GandalfProperty({ designType: String })
	webSite!: string | null;

}
